import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, filter, interval, mergeMap } from 'rxjs';
import { PollResponse } from '../model';
import { FrejaEidOrgService } from '../api/freja-org.service';
import { AuthenticationContextDatasourceService } from './authentication-context-datasource.service';

@Injectable()
export class FrejaEidOrgPollingService {
  private frejaEidOrgService = inject(FrejaEidOrgService);
  private authenticationContextDatasource = inject(AuthenticationContextDatasourceService);

  private readonly POLL_INTERVAL = 1000;
  private pollResponse: BehaviorSubject<PollResponse> = new BehaviorSubject<PollResponse>(null);

  public connect(id: string): Observable<PollResponse> {
    this.startPolling(id);

    return this.pollResponse.asObservable();
  }

  private startPolling(id: string): void {
    const idp = this.authenticationContextDatasource.getIdp();

    interval(this.POLL_INTERVAL)
      .pipe(
        mergeMap(() => this.frejaEidOrgService.getStatus(id, idp)),
        filter(result => result != null)
      )
      .subscribe(result => {
        this.pollResponse.next(result);
      });
  }
}
